module.exports = __webpack_public_path__ + "img/39.d65e8299.jpg";